/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   showMessagingModal thunk
 */

import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { oisEmpty } from '@zcode/nr-utils'
import Building from '@zcode/nr/es/shared/bizos/building'
import { MODAL_TYPE, type ShowMessagingModalData } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import type { GetState } from '../../../types'
import { receiveData } from '../../actions/messageModal'
import { openModal } from '../index'
import { default as fetchMessagingEntity } from './fetchMessagingEntity'

export const showMessagingModal =
  (data: ShowMessagingModalData & { showDatePicker?: boolean }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const isMobile = selectIsMobile(state)
    const { entity } = data

    // first show the modal
    dispatch(
      receiveData({
        ...data,
        isMobile,
        isFilterAd: entity.isFilterAd,
        showAgentInfo: typeof data.showAgentInfo !== 'undefined' ? data.showAgentInfo : !isMobile,
      })
    )
    dispatch(openModal(MODAL_TYPE.MESSAGE))

    // determine if we need to fetch more information
    // If we already have the full listing or building, there is no need
    // for us to fetch since we already have all the information we need to display the
    // message modal.
    if (!oisEmpty(entity) && !entity.hasNormalListingData && !(entity instanceof Building)) {
      void dispatch(
        fetchMessagingEntity(
          entity.isBuilding ? { buildingId: entity.buildingId } : { listingId: entity.listingId }
        )
      )
    }
  }
